import Council from "./index";

// Same browse-and-book page as Counselling, listing admission counsellors only.
const AdmissionCounsellor = (props) => <Council {...props} counsellorType="admission" />;

export default AdmissionCounsellor;
